import {BaseContainerModel} from '../base-container.model';
import {bl_webhook_topic_hdr_RowClass} from '../../dbschema/bl_webhook_topic_hdr.model';

export class WebhookTopicHdrContainerModel extends BaseContainerModel {
  bl_webhook_topic_hdr: bl_webhook_topic_hdr_RowClass = new bl_webhook_topic_hdr_RowClass();
}
